import { cn } from "@/utils/cn";

/** 일자 셀 내부 칩 — 호버는 부모 버튼이 `dayN`으로 처리 (여기서 스토어 호출 시 day 열이 깨짐) */
function ShiftCode({
  code,
  color,
  children,
}: {
  code: string;
  color?: string;
  children?: React.ReactNode;
}) {
  return (
    <div data-shift-display={code}>
      <div
        className={cn(
          "text-[15px] text-white  relative flex items-center justify-center font-semibold border-border aspect-square w-7 rounded-[5px] border ",
          !color && `bg-muted!`
        )}
        style={{ backgroundColor: color }}
      >
        <span className="truncate">{code}</span>
        {children}
      </div>
    </div>
  );
}

export default ShiftCode;
